import { Col, Row } from '@portalterreno/react-ui-core/Grid';
import AspectRatioIcon from '@portalterreno/react-ui-icons/AspectRatioIcon';
import AttachMoneyIcon from '@portalterreno/react-ui-icons/AttachMoneyIcon';
import LocationOnOutlinedIcon from '@portalterreno/react-ui-icons/LocationOnOutlinedIcon';
import StraightenOutlinedIcon from '@portalterreno/react-ui-icons/StraightenOutlinedIcon';
import React, { useMemo } from 'react';

import useProperty from '../../../hooks/useProperty';
import StyledStrikeThroughPrice from '../Price/StyledStrikeThroughPrice';
import Badge from './Badge';
import BadgesWrapper from './BadgesWrapper';
import DirectCredit from './DirectCredit';
import StyledWrapper from './StyledWrapper';

export type FeaturesProps = {
  priceLabel: string;
  totalSurfaceLabel: string;
  usefulSurfaceLabel?: string;
};

const Features: React.FC<FeaturesProps> = ({
  priceLabel,
  totalSurfaceLabel,
  usefulSurfaceLabel
}) => {
  const property = useProperty();

  let pricingBadge: React.ReactNode;

  if (property.campaignPricing) {
    // TODO: refactor Pricing and Badge components to be used here, to
    // keep only one pricing source
    pricingBadge = (
      <Badge
        body={property.campaignPricing[property.principalCurrency]}
        title='Precio con descuento desde'
        epigraph={
          <StyledStrikeThroughPrice>
            {property.pricing[property.principalCurrency]}
          </StyledStrikeThroughPrice>
        }
        icon={AttachMoneyIcon}
      />
    );
  } else {
    pricingBadge = (
      <Badge
        body={property.pricing[property.principalCurrency]}
        title={priceLabel}
        epigraph={property.pricing[property.secondaryCurrency]}
        icon={AttachMoneyIcon}
      />
    );
  }

  const location = useMemo(() => {
    if (property.communeId) {
      return property.communeName;
    }

    return property.cityName;
  }, [property.communeId, property.communeName, property.cityName]);

  return (
    <StyledWrapper>
      <Row>
        <Col>
          <BadgesWrapper>
            {pricingBadge}

            {property.usefulSurface && usefulSurfaceLabel && (
              <Badge
                body={`${property.usefulSurface.toLocaleString(
                  process.env.NEXT_PUBLIC_LANGUAGE
                )} ${property.surfaceUnit}`}
                title={usefulSurfaceLabel}
                icon={AspectRatioIcon}
              />
            )}

            <Badge
              body={`${property.surface.toLocaleString(
                process.env.NEXT_PUBLIC_LANGUAGE
              )} ${property.surfaceUnit}`}
              title={totalSurfaceLabel}
              icon={StraightenOutlinedIcon}
            />

            <Badge
              body={location}
              icon={LocationOnOutlinedIcon}
              title='Ubicación'
            />

            {property.highlightedFeatures.map((feature, index) => (
              <Badge
                key={index}
                body={feature.value}
                title={feature.name}
                image={feature.icon}
                description={feature.description}
              />
            ))}
          </BadgesWrapper>
        </Col>
      </Row>
      {property.directCredit && (
        <Row>
          <Col
            xs={4}
            lg={8}
          >
            <DirectCredit />
          </Col>
        </Row>
      )}
    </StyledWrapper>
  );
};

export default Features;
